"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PvdProgressIndicator =
/*#__PURE__*/
function (_HTMLElement) {
  _inherits(PvdProgressIndicator, _HTMLElement);

  _createClass(PvdProgressIndicator, [{
    key: "template",
    value: function template() {
      var templateEl = document.createElement('template');
      templateEl.innerHTML = "\n        <!-- Start Style --><style>:host{display:block;width:100%;padding-bottom:2.5em}pvd-progress-indicator{display:block;width:100%;padding-bottom:2.5em}.progress-bar-container{display:flex;flex-direction:row;width:100%;flex-wrap:nowrap;justify-content:center}.progress-bar-container .progress-item{display:flex;flex-direction:column;width:1.5em;height:1.5em;margin-left:-1px;background-color:transparent;border:solid 2px #ccc;border-radius:50%;position:relative;flex-grow:0;flex-shrink:0}.progress-bar-container .progress-item:first-of-type .progress-item-label{left:0;transform:translate(0, 100%);text-align:left}@media (min-width: 60em){.progress-bar-container .progress-item:first-of-type .progress-item-label{left:50%;right:initial;transform:translate(-50%, 100%);text-align:center}}.progress-bar-container .progress-item pvd-icon{display:none}.progress-bar-container .progress-item.current{border-color:#568200;transition:border-color 0.25s ease 0.25s}.progress-bar-container .progress-item.current .progress-item-label{display:block}.progress-bar-container .progress-item.completed{background-color:#568200;justify-content:center;align-items:center;border-color:#568200}.progress-bar-container .progress-item.completed pvd-icon{fill:#fff;display:block}.progress-bar-container .progress-item .progress-item-label{position:absolute;left:50%;bottom:-0.5em;display:none;text-align:center;width:200px;transform:translate(-50%, 100%);font-size:.75em;line-height:1.5em;font-weight:400}@media screen and (min-width: 32em){.progress-bar-container .progress-item .progress-item-label{font-size:.75em}}@media screen and (min-width: 60em){.progress-bar-container .progress-item .progress-item-label{font-size:.75em}}@media (min-width: 60em){.progress-bar-container .progress-item .progress-item-label{display:block}}.progress-bar-container .progress-item .progress-item-label.last-item{left:initial;right:0;transform:translate(0, 100%);text-align:right}@media (min-width: 60em){.progress-bar-container .progress-item .progress-item-label.last-item{left:50%;right:initial;transform:translate(-50%, 100%);text-align:center}}.progress-bar-container .progress-item .screen-reader-only{position:absolute;clip:rect(1px 1px 1px 1px);white-space:nowrap;padding:0;border:0;height:1px;width:1px;overflow:hidden}.progress-bar-container .progress-bar{height:4px;width:7em;margin-top:calc(1.5em / 2);max-width:10em;background-color:#ccc;background:-moz-linear-gradient(left, #568200 50%, #ccc 50%);background:-webkit-linear-gradient(left, #568200 50%, #ccc 50%);background:linear-gradient(to right, #568200 50%, #ccc 50%);background-size:200% 100%;background-position:right bottom;transition:background-position 0.25s ease-out;display:flex;flex-grow:1;flex-shrink:1}.progress-bar-container .progress-bar:last-child{display:none}.progress-bar-container .progress-bar.completed{background-position:left bottom}\n</style><!-- End Style -->\n        <div class=\"progress-bar-container\"></div>\n    ";
      return templateEl.content;
    }
  }, {
    key: "steps",
    get: function get() {
      return this.getAttribute("steps");
    },
    set: function set(val) {
      // an attribute can come in as an array if bound from Angular or another library
      if (Array.isArray(val)) {
        val = JSON.stringify(val);
      }

      this.setAttribute("steps", val);
    }
  }, {
    key: "stepIndex",
    get: function get() {
      return this.getAttribute("step-index");
    },
    set: function set(val) {
      this.setAttribute("step-index", val);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['steps', 'step-index'];
    }
  }]);

  function PvdProgressIndicator() {
    var _this;

    _classCallCheck(this, PvdProgressIndicator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PvdProgressIndicator).call(this));
    _this._stepIndex = 0;
    _this._steps;

    _this.attachShadow({
      mode: "open"
    }).appendChild(_this.template().cloneNode(true));

    return _this;
  }

  _createClass(PvdProgressIndicator, [{
    key: "stepChange",
    value: function stepChange() {
      if (Array.isArray(this._steps)) {
        this.updateSteps();
      }
    }
  }, {
    key: "stepStatus",
    value: function stepStatus(currStepIndex) {
      switch (true) {
        case currStepIndex < this._stepIndex:
          return "completed";

        case currStepIndex === this._stepIndex:
          return "current";

        case currStepIndex > this._stepIndex:
        default:
          return "inactive";
      }
    }
  }, {
    key: "updateSteps",
    value: function updateSteps() {
      while (this.shadowRoot.querySelector(".progress-bar-container").hasChildNodes()) {
        this.shadowRoot.querySelector(".progress-bar-container").removeChild(this.shadowRoot.querySelector(".progress-bar-container").lastChild);
      }

      if (this._steps) {
        for (var i = 0; i < this._steps.length; i++) {
          var stepItem = document.createElement("div");
          var progressBar = document.createElement("div");
          var isLast = "";

          if (i == this._steps.length - 1) {
            isLast = "last-item";
          }

          var currStepStatus = this.stepStatus(i);
          stepItem.classList.add("progress-item");
          progressBar.classList.add("progress-bar");
          stepItem.innerHTML = "\n                    <pvd-icon aria-hidden=\"true\" icon=\"checkmark\"></pvd-icon>\n                    <div class=\"progress-item-label ".concat(isLast, "\">\n                        ").concat(this._steps[i], "\n                        <span class=\"screen-reader-only\">Step ").concat(i + 1, " of ").concat(this._steps.length, ", ").concat(currStepStatus, "</span>\n                    </div>\n                ");

          if (i < this._stepIndex) {
            stepItem.classList.add("completed");
            progressBar.classList.add("completed");
          }

          if (this._stepIndex == i) {
            stepItem.classList.add("current");
          }

          this.shadowRoot.querySelector('.progress-bar-container').appendChild(stepItem);
          this.shadowRoot.querySelector('.progress-bar-container').appendChild(progressBar);
        }
      }
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case 'steps':
          if (newValue) {
            this._steps = JSON.parse(newValue);
          }

          break;

        case 'step-index':
          this._stepIndex = +newValue;

          if (this._stepIndex < 0) {
            this.setAttribute("step-index", "0");
          }

          if (this._steps && this._stepIndex > this._steps.length) {
            this.setAttribute("step-index", this._steps.length);
          }

          break;
      }

      if (Array.isArray(this._steps)) {
        this.updateSteps();
      }
    }
  }]);

  return PvdProgressIndicator;
}(_wrapNativeSuper(HTMLElement));

if (!!customElements.get('pvd-progress-indicator') == false) {
  customElements.define("pvd-progress-indicator", PvdProgressIndicator);
}